export interface ReturnsSettingsExperienceInput {
  isRedoUser: boolean;
  teamInRollout: boolean;
  /** Redo turned the new page on for this team from the admin app. */
  enabledForTeam: boolean;
  requiredForRedoUsers: boolean;
  prefersLegacy: boolean;
}

export function resolveReturnsSettingsExperience({
  isRedoUser,
  teamInRollout,
  enabledForTeam,
  requiredForRedoUsers,
  prefersLegacy,
}: ReturnsSettingsExperienceInput): { useNewUi: boolean; canSwitch: boolean } {
  const available =
    teamInRollout || enabledForTeam || (isRedoUser && requiredForRedoUsers);
  return { useNewUi: available && !prefersLegacy, canSwitch: available };
}
